import { ApiWorkflowConstants } from "../../../shared/constants/api-constants/api-workflow.constants";
export class ViewApplicationConstants {
    static SHARE_LINK_TEXT = "Share application link";
    static SEND_US_FEEDBACK_LINK_TEXT = "Send Us Feedback";
    static BUILD_INFO_LINK_TEXT = "Build Info";
    static WORKFLOW_STEP_META_URL = ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_STEP_META;
    static VIEW_APPLICATION_HEADING_TEXT = "View application";
}
